// Cart interactions for the madeleine customizer.
(() => {
  const storageKey = 'proost-custom-madeleine-v2';
  const money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  const pricing = window.ProostCustomMadeleinePricing;
  if (!pricing) return;
  const defaults = { weight: '30', shell: 'Blanc', shellColor: '#f4ead5', ink: 'Noir', inkColor: '#38231f', quantity: 30, scale: 48, x: 0, y: 0, logo: '', logoName: '' };
  const readState = () => { try { return { ...defaults, ...JSON.parse(localStorage.getItem(storageKey) || '{}') }; } catch { return { ...defaults }; } };
  const writeState = (state) => { try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch { /* Keep the preview usable without storage. */ } };

  document.querySelectorAll('[data-custom-madeleine]').forEach((root) => {
    const builder = root.closest('[data-order-builder]');
    const state = readState();
    const products = [root.querySelector('[data-custom-product]')];
    const artwork = root.querySelector('[data-custom-artwork]');
    const resizeHandle = root.querySelector('[data-custom-resize]');
    const logos = [root.querySelector('[data-custom-logo]')];
    const weightInputs = [...root.querySelectorAll('input[name="custom-weight"]')];
    const shellInputs = [...root.querySelectorAll('input[name="custom-shell"]')];
    const inkInputs = [...root.querySelectorAll('input[name="custom-ink"]')];
    const upload = root.querySelector('[data-custom-upload]');
    const removeLogo = root.querySelector('[data-custom-remove-logo]');
    const quantity = root.querySelector('[data-custom-quantity]');
    const status = root.querySelector('[data-custom-status]');
    const defaultStatus = status.textContent;
    const tierNote = root.querySelector('[data-custom-tier]');
    const addToCart = root.querySelector('[data-custom-add]');
    const requestQuote = root.querySelector('[data-custom-request-quote]');
    const byValue = (inputs, value) => inputs.find((input) => input.value === value) || inputs[0];
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const lineProperties = (pickup) => ({
      Format: `${state.weight} g`,
      Coque: state.shell,
      Marquage: state.logo ? 'Logo importé' : 'Sans marquage',
      ...(state.logoName ? { Logo: state.logoName } : {}),
      'Couleur du marquage': state.ink,
      Retrait: pickup
    });

    byValue(weightInputs, state.weight).checked = true;
    byValue(shellInputs, state.shell).checked = true;
    byValue(inkInputs, state.ink).checked = true;

    function render(persist = true) {
      state.quantity = Math.max(30, state.quantity);
      const weight = byValue(weightInputs, state.weight);
      const tier = pricing.tierFor(state.weight, state.quantity);
      const quoteRequired = !tier;
      products.forEach((product) => {
        const base = product.querySelector('[data-custom-base]');
        base.src = weight.dataset.imageUrl;
        base.width = Number(weight.dataset.imageWidth);
        base.height = Number(weight.dataset.imageHeight);
        product.style.setProperty('--madeleine-mask', `url("${weight.dataset.imageUrl}")`);
        product.style.setProperty('--plaque-y', `${weight.dataset.plaqueY}%`);
        product.style.setProperty('--shell-color', state.shellColor);
        product.style.setProperty('--ink-color', state.inkColor);
        product.style.setProperty('--logo-scale', `${state.scale}%`);
        product.style.setProperty('--logo-x', `${state.x}%`);
        product.style.setProperty('--logo-y', `${state.y}%`);
      });
      root.querySelector('[data-custom-scale]').dataset.weight = state.weight;
      artwork.hidden = !state.logo;
      logos.forEach((logo) => {
        logo.hidden = !state.logo;
        logo.style.maskImage = state.logo ? `url(${state.logo})` : '';
        logo.style.webkitMaskImage = state.logo ? `url(${state.logo})` : '';
      });
      removeLogo.hidden = !state.logo;
      quantity.textContent = state.quantity;
      root.querySelector('[data-custom-total]').textContent = quoteRequired ? 'Sur devis' : money.format(tier.unitPriceCents * state.quantity / 100);
      tierNote.textContent = quoteRequired
        ? 'Au-delà de 200 pièces, votre projet est préparé sur devis.'
        : `Tarif dégressif · ${tier.label} pièces · ${money.format(tier.unitPriceCents / 100)} HT / pièce`;
      addToCart.hidden = quoteRequired;
      requestQuote.hidden = !quoteRequired;
      if (persist) writeState(state);
    }

    weightInputs.forEach((input) => input.addEventListener('change', () => { state.weight = input.value; render(); }));
    shellInputs.forEach((input) => input.addEventListener('change', () => { state.shell = input.value; state.shellColor = input.dataset.color; render(); }));
    inkInputs.forEach((input) => input.addEventListener('change', () => { state.ink = input.value; state.inkColor = input.dataset.color; render(); }));
    let gesture;
    function beginGesture(event, type) {
      if (gesture || (event.pointerType === 'mouse' && event.button !== 0)) return;
      event.preventDefault();
      event.stopPropagation();
      const productRect = products[0].getBoundingClientRect();
      const target = event.currentTarget;
      target.setPointerCapture(event.pointerId);
      gesture = { type, target, pointerId: event.pointerId, startX: event.clientX, startY: event.clientY, x: state.x, y: state.y, scale: state.scale, centerX: productRect.left + productRect.width / 2, centerY: productRect.top + productRect.height / 2 };
      gesture.distance = Math.hypot(event.clientX - gesture.centerX, event.clientY - gesture.centerY) || 1;
      artwork.classList.add('is-manipulating');
    }
    function moveGesture(event) {
      if (!gesture || event.pointerId !== gesture.pointerId) return;
      const productRect = products[0].getBoundingClientRect();
      if (gesture.type === 'move') {
        state.x = clamp(gesture.x + (event.clientX - gesture.startX) / productRect.width * 100, -34, 34);
        state.y = clamp(gesture.y + (event.clientY - gesture.startY) / productRect.height * 100, -34, 34);
      } else {
        const distance = Math.hypot(event.clientX - gesture.centerX, event.clientY - gesture.centerY);
        state.scale = clamp(gesture.scale * distance / gesture.distance, 38, 125);
      }
      render(false);
    }
    function endGesture(event) {
      if (!gesture || event.pointerId !== gesture.pointerId) return;
      gesture.target.releasePointerCapture(event.pointerId);
      gesture = undefined;
      artwork.classList.remove('is-manipulating');
      writeState(state);
    }
    artwork.addEventListener('pointerdown', (event) => beginGesture(event, 'move'));
    resizeHandle.addEventListener('pointerdown', (event) => beginGesture(event, 'resize'));
    artwork.addEventListener('pointermove', moveGesture);
    artwork.addEventListener('pointerup', endGesture);
    artwork.addEventListener('pointercancel', endGesture);
    artwork.addEventListener('keydown', (event) => {
      const actions = { ArrowLeft: ['x', -2], ArrowRight: ['x', 2], ArrowUp: ['y', -2], ArrowDown: ['y', 2], '-': ['scale', -4], '+': ['scale', 4] };
      const action = actions[event.key];
      if (!action) return;
      event.preventDefault();
      const [key, amount] = action;
      state[key] = clamp(state[key] + amount, key === 'scale' ? 38 : -34, key === 'scale' ? 125 : 34);
      render();
    });
    root.querySelector('[data-custom-decrement]').addEventListener('click', () => { state.quantity = Math.max(30, state.quantity - 10); render(); });
    root.querySelector('[data-custom-increment]').addEventListener('click', () => { state.quantity += 10; render(); });
    removeLogo.addEventListener('click', () => { state.logo = ''; state.logoName = ''; upload.value = ''; render(); });
    upload.addEventListener('change', () => {
      const file = upload.files?.[0];
      if (!file) return;
      if (file.size > 2_000_000) { status.textContent = 'Ce fichier dépasse 2 Mo.'; upload.value = ''; return; }
      const reader = new FileReader();
      reader.addEventListener('load', () => { state.logo = String(reader.result); state.logoName = file.name; status.textContent = 'Logo importé — ajustez sa taille et sa position.'; render(); });
      reader.readAsDataURL(file);
    });
    requestQuote.addEventListener('click', () => {
      builder.dispatchEvent(new CustomEvent('proost:request-quote', { detail: { quantity: state.quantity } }));
    });
    addToCart.addEventListener('click', async () => {
      status.textContent = 'Ajout de votre création…';
      let optimisticItem;
      try {
        const variant = await pricing.variantFor(state.weight, state.quantity);
        if (!variant) throw new Error('Custom tier unavailable');
        const pickup = builder.querySelector('input[name="pickup"]:checked')?.value || '';
        const tier = pricing.tierFor(state.weight, state.quantity);
        optimisticItem = { id: `custom-${Date.now()}`, name: `Madeleine personnalisable ${state.weight} g`, quantity: state.quantity, cents: tier.unitPriceCents * state.quantity };
        builder.dispatchEvent(new CustomEvent('proost:cart-optimistic-add', { detail: optimisticItem }));
        const response = await fetch(root.dataset.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: state.quantity, properties: lineProperties(pickup) }] }) });
        if (!response.ok) throw new Error('Cart request failed');
        const cartResponse = await fetch(builder.dataset.cartUrl, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        builder.dispatchEvent(new CustomEvent('proost:cart-updated', { detail: await cartResponse.json() }));
        window.ProostAnalytics?.track('cart_item_added', {
          product_name: `Madeleine personnalisable ${state.weight} g`,
          quantity: state.quantity,
          value: tier.unitPriceCents * state.quantity / 100,
          pickup_location: pickup,
          shell_color: state.shell,
          ink_color: state.ink,
          logo_uploaded: Boolean(state.logo)
        });
        status.textContent = defaultStatus;
      } catch {
        if (optimisticItem) builder.dispatchEvent(new CustomEvent('proost:cart-optimistic-remove', { detail: optimisticItem }));
        status.textContent = 'Impossible d’ajouter la création. Réessayez.';
      }
    });
    render();
  });
})();
